import { render, staticRenderFns } from "./EditPatches.vue?vue&type=template&id=7c8497a6&scoped=true&"
import script from "./EditPatches.vue?vue&type=script&lang=ts&"
export * from "./EditPatches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8497a6",
  null
  
)

export default component.exports